import {Component, ElementRef, EventEmitter, HostListener, Input, Output} from '@angular/core';
import {Form, FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {getDate, addMonths} from '@progress/kendo-date-math';
import {stateData} from "../../static/states";
import {genderData} from "../../static/gender";
@Component({
    selector: 'app-patient-form',
    templateUrl: './patient-form.component.html',
    styleUrls: ['./patient-form.component.scss'],
    standalone: false
})
export class PatientFormComponent {
  @Input() formGroup!: FormGroup;
  @Input() focusedField: string | null = null;// parent passes which field is focused
  @Input() patientAutoSearched = false;
  @Output() inputFocus = new EventEmitter<string>();
  @Output() inputClick = new EventEmitter<string>();
  @Output() inputTabbed = new EventEmitter<string>();
  @Input() searchComplete = false;
  @Input() isActive = false;
  @Input() isBatch = false;
  @Input() set clearFocusTrigger(value: boolean) {
    if (value) {
      this.focusedFieldParent = null;
      // const inputs = this.elRef.nativeElement.querySelectorAll('input, textarea');
      // inputs.forEach((el: any) => el.blur());
    }
  }
  private _clearTrigger = false;
  public focusedFieldParent: string | null = null; // each instance gets its own
  public gender = genderData;
  public states = stateData;
  public maxDate: Date = getDate(new Date());
  public phoneMask = '(000) 000-0000';
  constructor(private elRef: ElementRef) {}

  public onFieldFocused(field: any) {
    this.focusedFieldParent = field;
    this.inputFocus.emit(field);
  }

  public onFieldClicked(field: any) {
    this.inputClick.emit(field);
  }

  public onKeyDown(event: KeyboardEvent, field: any) {
    if (event.key === 'Tab') {
      this.inputTabbed.emit(field);
    }
  }

  public isFieldFocused(field: string): boolean {
    if (this.isBatch) {
      return this.isActive && this.focusedFieldParent === field;
    } else {
      return this.focusedFieldParent === field;
    }
  }
}
